import axios from 'axios';

export const initialState = {
};

export const mutations = {

  RESET(state) {
    Object.keys(state).forEach((attr) => { state[attr] = initialState[attr]; });
  },
};

export const actions = {

  async uploadMedia(storeUtils, file) {
    const payload = new FormData();
    payload.append('file', file);

    const headers = { 'Content-Type': 'multipart/form-data' };

    const { data } = await axios.post('/media/upload', payload, { headers });
    return data;
  }

};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
